import { VisitorEvent } from './../models/visitor.event';
import { EventTimeService } from './../../event-calendar/services/event.time.service';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/common/services/config/config.service';
import { VisitorPlace } from '../models/visitor.place';
import { JobPosting } from '../models/job.posting';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  constructor(private _eventTimeService: EventTimeService) {}

  public toMailableEvent(hubName: string, item: VisitorEvent, currentUrl?: string): string {
    let description = item.description || '';
    description = this.stripHtml(description).replace(/\s+/g, ' ').trim();

    const words = description.split(' ');
    if (words.length > 90) description = words.slice(0, 90).join(' ') + '…';

    const title = (item.name || item.title || '').replace(/&/g, 'and');
    const startTime = this._eventTimeService.formatToShareTime(item.startTime);
    const organiser = item.owner.name || '';
    const link = currentUrl || this.getEventUrl(hubName, item);

    const bodyText = [
      description,
      '',
      `Start at: ${startTime}`,
      `Organizer: ${organiser}`,
      '',
      link,
    ].join('\n');

    const mailto =
      'mailto:' + `?subject=${encodeURIComponent(title)}` + `&body=${encodeURIComponent(bodyText)}`;

    return mailto;
  }

  public toMailablePlace(hubName: string, item: VisitorPlace, currentUrl?: string): string {
    /* ----------  CLEAN DESCRIPTION  ---------- */
    let description = this.stripHtml(item.description || item.title || '')
      .replace(/\s+/g, ' ') // collapse whitespace
      .trim();

    const words = description.split(' ');
    if (words.length > 90) description = words.slice(0, 90).join(' ') + '…';

    /* ----------  OTHER TEXT FIELDS  ---------- */
    const name = (item.name || item.title || '').replace(/&/g, 'and');
    const category = (item.category || '').replace(/&/g, 'and');
    const address = ((item.address?.address ?? item.address) || '').toString().replace(/&/g, 'and');

    const link = currentUrl || window.location.href;

    /* ----------  PLAIN‑TEXT BODY  ---------- */
    const bodyText = [
      description,
      '',
      `Category: ${category}`,
      `Address:  ${address}`,
      '',
      link,
    ].join('\n');

    /* ----------  BUILD ENCODED mailto: HREF  ---------- */
    const mailto =
      'mailto:' + `?subject=${encodeURIComponent(name)}` + `&body=${encodeURIComponent(bodyText)}`;

    return mailto;
  }

  public toMailableJob(hubName: string, item: JobPosting, currentUrl?: string): string {
    let description = this.stripHtml(item.description || item.title || '')
      .replace(/\s+/g, ' ') // collapse whitespace
      .trim();

    const words = description.split(' ');
    if (words.length > 90) description = words.slice(0, 90).join(' ') + '…';

    const title = (item.title || '').replace(/&/g, 'and');
    const link = currentUrl || this.getJobUrl(hubName, item);

    const bodyText = [description, '', '', link].join('\n');

    const mailto =
      'mailto:' + `?subject=${encodeURIComponent(title)}` + `&body=${encodeURIComponent(bodyText)}`;

    return mailto;
  }

  public getEventUrl(hubName, item: any) {
    let url = environment.serverDomain;
    url = `${url}/${hubName}/events/details/${item._id}`;
    //url = url.substring(0, url.lastIndexOf('/')) + '/events/' + item._id;
    return url;
  }

  public getJobUrl(hubName, item: any) {
    let url = environment.serverDomain;
    url = `${url}/${hubName}/job-board/?ig-job=${item._id}`;
    return url;
  }

  public stripHtml(source: string): string {
    if (!source) return '';

    // First, remove all HTML/XML tags including their content for script/style tags
    let cleaned = source
      // Remove script tags and their content
      .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
      // Remove style tags and their content
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
      // Remove all other HTML tags
      .replace(/<[^>]*>/g, '')
      // Decode common HTML entities
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      // Remove any remaining HTML entities (numeric)
      .replace(/&#\d+;/g, '')
      // Remove any remaining HTML entities (named)
      .replace(/&[a-zA-Z]+;/g, '')
      // Clean up multiple spaces, tabs, newlines
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();

    return cleaned;
  }
}
